export enum EDietSemiproductsDetailsTabs {
	GENERAL = 'general',
	INGRIDIENTS = 'ingridients',
	PRODUCTION_STAGES = 'production_stages',
	RELATED_MEALS = 'related_meals',
	ALTERNATIVE_MATERIALS = 'alternative_materials',
	HISTORY = 'history',
}

export enum EDietSemiProductWotStatusFilter {
	MISMATCH = 'mismatch',
	NO_PRODUCTION_STAGES = 'no_production_stages',
}

export const DIET_SEMI_PRODUCT_WOT_STATUS_FILTER_OPTIONS: ISelectOption<EDietSemiProductWotStatusFilter | null>[] = [
	{ label: 'Wszystkie', value: null },
	{ label: 'Niezgodne WOTep z WOT', value: EDietSemiProductWotStatusFilter.MISMATCH },
	{ label: 'Brak etapów (WOTep = 0)', value: EDietSemiProductWotStatusFilter.NO_PRODUCTION_STAGES },
]
